window.addEventListener('load', async () => {
    const menu = document.getElementById('apollo-verticalmenu');
    if(menu){
        const open = document.querySelector('#apollo-verticalmenu .title_block');
        open.addEventListener("click", function(){
            document.getElementById('categories_nav').classList.add('open');
            document.querySelector('body').style.overflow = 'hidden';
        });
        const closeElem = ['#verticalmenu-header-close', '.verticalmenu-background'];
        closeElem.map(e => {
            const elm = document.querySelector(e);
            elm.addEventListener("click", function(){
                document.getElementById('categories_nav').classList.remove('open');
                document.querySelector('body').style.overflow = '';
            });
        });
    }
});